import { CONFIG } from "@/config-global";
import { supabase } from "@/lib/supabase";
import { clearPendingInviteAuth } from "@/utils/invite-auth-flow";
import { clearLinkedInConfirmationRetry, markLinkedInSignInStarted } from "@/utils/linkedin-auth-error";
import { linkedInLoginHintParams, requiresLinkedInSso } from "@/utils/linkedin-sso-routing";

/** True when this address may only sign in with LinkedIn. */
export function isLinkedInOnlyEmail(email: string | null | undefined): boolean {
  return requiresLinkedInSso(email, {
    enabled: CONFIG.auth.linkedInEnabled,
    domains: CONFIG.auth.linkedInDomains,
  });
}

/**
 * Starts "Continue with LinkedIn". Shared by the login and invite screens so
 * both mark the sign-in for PostAuth's /userinfo check. PostAuth only runs that
 * check for sign-ins that started here, because Google also returns a
 * provider_token.
 */
export async function startLinkedInSignIn(email?: string | null) {
  // A stale invite left by an earlier password or Google attempt would make
  // PostAuth compare emails before sso-verify has linked the account. That
  // comparison signs out the blank-email duplicate a LinkedIn sign-in first
  // creates. PostAuth finds the invite again through list-pending.
  try {
    clearPendingInviteAuth(sessionStorage);
  } catch {
    // Blocked storage holds no stale invite either.
  }
  markLinkedInSignInStarted();
  clearLinkedInConfirmationRetry();
  const { error } = await supabase.auth.signInWithOAuth({
    provider: CONFIG.auth.linkedInProviderId as any,
    options: {
      redirectTo: window.location.origin + "/auth/post-auth",
      queryParams: linkedInLoginHintParams(email),
    },
  });
  if (error) throw error;
}
